export const getStoreName = () => {
    const { hostname } = window.location;
    const domainParts = hostname.split('.');

    if (domainParts.length > 1) {
        return domainParts[0];
    }

    return null;
};
